import { useCart } from '@zenbusiness/application-commons-ecommerce';

import useFlowState from '#client/hooks/flow/useFlowState';

/**
 * Custom hook to update the shopping cart with business information.
 *
 * @returns {Function} A function that updates the cart with the provided business information.
 */
export default function useUpdateCart() {
  const cart = useCart();
  const { businessInfo } = useFlowState();

  const updateCart = async (data) => {
    return cart.updateCart({
      proposedBusiness: {
        formationCounty: data.formationCounty || '',
        goals: data.goals || '',
        hasEmployees: data.hasEmployees || '',
        homeBased: data.homeBased || false,
        isDao: data.isDao || false,
        isSCorp: data.isSCorp || false,
        jurisdictionState: data.jurisdictionState || '',
        launchStatus: data.launchStatus || '',
        name: data.name || '',
        priorExperience: data.priorExperience || '',
        type: data.entityType || businessInfo.entityType
      }
    });
  };

  return updateCart;
}
